<template>
  <div>
<!--    <img class="talk_img" :src="imgUrl + banner" alt />-->
    <img class="talk_img" src="../../assets/img/talk/img_4_1.png" alt />
    <!-- 内容区域 -->
    <div class="talk_box">
      <!-- tabs -->
      <div>
        <div class="talk_tabs">
          <div
            class="tabs_item"
            :class="{ talkCurrent: talkCurrent == index }"
            v-for="(item, index) in tabsList"
            :key="index"
            @click="changeTabs(index)"
          >
            {{ item }}
            <div v-if="talkCurrent == index" class="line"></div>
          </div>
          <div class="fabu" :class="{ fabuActive: fabuFlag }" @click="fabuShow">
            <img v-if="fabuFlag" src="../../assets/img/talk/icon_4_23.png" alt />
            <img v-else src="../../assets/img/talk/icon_4_4.png" alt />
            发布
          </div>
        </div>
        <div class="fabu_body" v-if="fabuFlag">
          <input v-model="title" class="fabu_top" placeholder="这是标题" />
          <div class="fabu_content">
            <textarea
              v-model="content"
              placeholder="快来发表你的想法吧！快来发表你的想法吧！快来发表你的想法吧！（内容）"
              name
              id
              cols="30"
              rows="10"
            ></textarea>
            <div class="fabu_btm">
              <div class="fabu_box">
                <div class="fabu_left">
                  <!-- <div class="img1">
                    <img src="../../assets/img/talk/icon_4_12.png" alt />
                  </div>-->
                  <!-- <div class="img2">
                    <img
                      v-if="imgShow"
                      @click="imgShow = false"
                      src="../../assets/img/talk/icon_4_15.png"
                      alt
                    />
                    <img
                      v-else
                      @click="imgShow = true"
                      src="../../assets/img/talk/icon_4_13.png"
                      alt
                    />
                  </div> -->
                </div>
                <div class="fabu_rt" @click="announce()">发表</div>
              </div>
              <div class="fabu_imgs" v-if="imgShow">
                <div class="fabu_imgs_top">图片({{ imageUrlList.length }}/9)</div>
                <div class="fabu_imgs_bd">
                  <div class="imgs_box">
                    <el-upload
                      action
                      list-type="picture-card"
                      :http-request="fnUploadRequest"
                      :show-file-list="false"
                      :before-upload="beforeUpload"
                    >
                      <i class="el-icon-plus" />
                    </el-upload>
                    <div class="img_list">
                      <div
                        @mouseenter="closeFlag = index"
                        @mouseleave="closeFlag = -1"
                        class="img_item"
                        v-for="(item, index) in imageUrlList"
                        :key="index"
                        alt
                      >
                        <img :src="item" />
                        <img
                          @click="closeImg(index)"
                          v-if="closeFlag == index"
                          class="close"
                          src="../../assets/img/talk/icon_4_17.png"
                          alt
                        />
                      </div>
                      <div @click.stop="uploadHeadImg" class="add_img">
                        <img src="../../assets/img/talk/icon_4_24.png" alt />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 论坛列表 -->
      <div class="talk_body">
        <!-- 精选 -->
        <div class="talk_top">
          <div class="top_left">
            <img src="../../assets/img/talk/icon_4_5.png" alt />
            <div>精选</div>
          </div>
          <!-- <div class="top_rt">
            <div>最热</div>
            <img src="../../assets/img/talk/icon_4_6.png" alt />
          </div>-->
        </div>
        <!-- 帖子列表 -->
        <div class="tie_list">
          <div class="tie_item" v-for="(item1, index1) in tieList" :key="index1">
            <div class="tie_left">

<!--              <img :src="item1.header ? imgUrl + item1.header : '../../assets/img/home/img8.png' " alt />-->

              <img src="../../assets/img/home/girl.jpg" alt />

              <div>{{ item1.name }}</div>
            </div>
            <div class="tie_tight" @click="goDetail(item1.id)">
              <div class="tie_title">
                <div>{{ item1.title }}</div>
                <div>{{ (item1.addtime * 1000) | dateFormat }}</div>
              </div>
              <div class="tie_desc">{{ item1.content }}（正文）</div>
              <div class="tie_img">
                <img v-for="(item2, index2) in item1.atlas" :key="index2" :src="imgUrl + item2" alt />
              </div>
              <div class="tie_btm">
                <div class="btm_left"></div>
                <div class="btm_right">
                  <!-- <div class="btm_item">
                    <img class="img1" src="../../assets/img/talk/icon_4_8.png" alt />
                    <div>{{ item1.collection }}</div>
                  </div> -->
                  <div class="btm_item">
                    <img class="img2" src="../../assets/img/talk/icon_4_10.png" alt />
                    <div>{{ item1.comment }}</div>
                  </div>
                  <div class="btm_item">
                    <img class="img3" src="../../assets/img/talk/icon_4_11.png" alt />
                    <div>{{ item1.praise }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 分页功能 -->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage4"
          :page-size="limit"
          layout="total,  prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { forumIndex, postForum, uploadImg } from "../../assets/js/api.js";
import axios from "axios";
import Bus from "../../bus.js";
export default {
  data() {
    return {

      limit: 4,

      total: 0,
      imgUrl: "http://education.hnzye.cn",
      banner: "",
      hotList: [],
      title: "",
      content: "",
      atlas: "",
      action: "uploadimage",
      file: "",
      imageUrl: "",

      imgShow: false,
      closeFlag: -1,
      imageUrlList: [],

      tabsList: ["知识分享", "疑难求教", "课趣", "校天地"],
      tieList: [],
        page: 1,
        type: 1,
      talkCurrent: 0,
      currentPage4: 1,
      fabuFlag: false,
      dialogimageUrlList: "",
      dialogVisible: false,
    };
  },
  mounted() {
    this.getIndex();
  },
  methods: {
    getIndex() {
      forumIndex(window.localStorage.getItem("siteId"),this.type, this.page, this.limit).then((res) => {
        if (res.code == 200) {
          this.total = res.data.userBbs.total;
          this.banner = res.data.banner;
          this.tieList = res.data.userBbs.records;
          this.hotList = res.data.hotBbs;
          this.sendIndex();
        }
      });
    },
    goDetail(id) {
      // console.log(id);
      this.$emit("child-event", 3);
      Bus.$emit("id", id);
    },
    sendIndex() {
      this.$emit("func", this.hotList.slice(0, 10));
    },
    changeTabs(i) {
      this.talkCurrent = i;
      this.page = 1;
      this.type = this.talkCurrent - 0 + 1;
      this.currentPage4 = 1;
      console.log(this.currentPage4);
      this.getIndex();
      console.log(this.talkCurrent);
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getIndex();
      console.log(`当前页: ${val}`);
    },
    // 显示发布框
    fabuShow() {
      this.fabuFlag = !this.fabuFlag;
    },
    // 上传图片
    uploadHeadImg: function () {
      if (this.imageUrlList.length == 9) {
        this.$message.error("最多选择9张图片！");
        return;
      }
      this.$el.querySelector(".hiddenInput").click();
    },
    // 将头像显示
    handleFile: function (e) {
      console.log(e);
      let $target = e.target || e.srcElement;
      let file = $target.files[0];
      console.log(file);
      var reader = new FileReader();
      reader.onload = (data) => {
        console.log(data);
        let res = data.target || data.srcElement;
        console.log(res);
        console.log(document.getElementById("test"));
        // uploadImg(this.action,res.result).then(res1=>{
        //   console.log(res1)
        // })
        this.imageUrlList.push(res.result);
      };

      reader.readAsDataURL(file);
    },
    // 取消图片
    closeImg(i) {
      console.log(i);
      // this.imageUrlList.pop(i);
      this.imageUrlList.splice(i, 1);
    },
    // 发布
    announce() {
      if (!this.title) {
        this.$message.error("请输入标题");
        return;
      }
      if (!this.content) {
        this.$message.error("请输入标题");
        return;
      }

      console.log(
        this.title,
        this.content,
        JSON.stringify(this.imageUrlList),
        this.type
      );
      postForum(
        this.title,
        this.content,
        JSON.stringify(this.imageUrlList),
        this.type
      ).then((res) => {
        if (res.code == 200) {
          this.fabuFlag = false;
          this.title=""
          this.content=""
          this.$message.success("已发表");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    fnUploadRequest: function (params) {
      const _file = params.file;
      // 通过 FormData 对象上传文件
      var formData = new FormData();
      formData.append("file", _file);
      // 发起请求
      // let res = await this.$store.dispatch("upload/upload", {
      //   data: formData,
      //   uploadKey: this.uploadKey,
      // });
      formData.getAll("file");
      console.log(formData.getAll("file"));
      // uploadImg(formData).then(res1=>{
      //     console.log(res1)
      //   })
      let that = this;
      // if (res && this.type == "list") {
      //   let arr = this.imageUrl;
      //   arr.push(res.fileNameUrl);
      //   // this.$emit("saveUrl", arr);
      // } else if (res) {
      //   console.log(res.fileNameUrl);
      //   // this.$emit("saveUrl", res.fileNameUrl);
      // }
    },
    beforeUpload(file) {
      //todo
      let types = ["image/jpeg", "image/gif", "image/bmp", "image/png"];

      const isImage = types.includes(file.type);
      console.log(file);
      const isLtSize = file.size / 1024 / 1024 < 5;

      if (!isImage) {
        this.$message.error("上传图片只能是 JPG、GIF、BMP、PNG 格式!");

        return false;
      }

      if (!isLtSize) {
        this.$message.error("上传图片大小不能超过 500KB!");

        return false;
      }

      return true;
    },
  },
};
</script>

<style lang="less" scoped>
.talkCurrent {
  opacity: 1 !important;
}

.fabuActive {
  color: #029aff !important;
}

.el-pagination {
  margin: 30px 0;
  text-align: center;
}

.talk_img {
  width: 100%;
  height: 350px;
}

.fabu_body {
  width: 805px;
  background-color: #fff;
  // position: absolute;
  // bottom: -20px;
  // left: 0;
  position: relative;
  top: -10px;

  ::placeholder {
    //通过这个设置
    color: #999;
    font-size: 16px;
  }

  .fabu_top {
    width: 100%;
    height: 50px;
    border: 1px solid #eaeaea;
    border-top: none;
    padding: 0 15px;
    box-sizing: border-box;
  }

  .fabu_content {
    position: relative;
    width: 100%;
    height: 132px;
    border: none;
    border: 1px solid #eaeaea;
    padding-top: 10px;
    box-sizing: border-box;
    background-color: #f2f2f2;

    textarea {
      width: 100%;
      height: 80px;
      resize: none;
      outline: none;
      border: none;
      border-bottom: 1px solid #eaeaea;
      padding: 15px;
      box-sizing: border-box;
      background-color: #fff;
      vertical-align: top;

      ::placeholder {
        //通过这个设置
        color: #999;
        font-size: 16px;
      }
    }

    .fabu_btm {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      background-color: #fff;
      // overflow: hidden;

      .fabu_box {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        height: 40px;
        background-color: #fff;

        .fabu_left {
          display: flex;
          align-items: center;

          img {
            cursor: pointer;
          }

          .img1 {
            width: 20px;
            height: 20px;
            margin: 0 20px;
          }

          .img2 {
            width: 22px;
            height: 18px;
            margin: 0 20px;
          }
        }

        .fabu_rt {
          width: 101px;
          height: 40px;
          line-height: 40px;
          background: #029aff;
          font-size: 18px;
          color: #fff;
          text-align: center;
          cursor: pointer;
        }
      }

      .fabu_imgs {
        position: absolute;
        top: 40px;
        left: 0;
        width: 100%;
        background-color: #fff;
        box-shadow: 0px 10px 35px 0px rgba(0, 0, 0, 0.1);

        .fabu_imgs_top {
          width: 100%;
          height: 40px;
          line-height: 40px;
          // border: 1px solid #eaeaea;
          border-bottom: 1px solid #eaeaea;
          border-top: 1px solid #eaeaea;
          font-size: 14px;
          color: #9a9a9a;
          padding: 0 20px;
          box-sizing: border-box;
        }

        .fabu_imgs_bd {
          display: flex;
          width: 100%;
          padding: 20px;
          box-sizing: border-box;
          border-bottom: 1px solid #eaeaea;

          .imgs_box {
            // display: flex;
            // flex-wrap: wrap;
            // max-width: 380px;
            .img_list {
              display: flex;
              flex-wrap: wrap;
              max-width: 380px;

              .img_item {
                position: relative;
                flex: 0 0 31%;
                margin-right: 10px;
                margin-bottom: 10px;

                img {
                  width: 120px;
                  height: 120px;
                }

                .close {
                  position: absolute;
                  top: 10px;
                  right: 10px;
                  z-index: 2;
                  width: 14px;
                  height: 14px;
                  cursor: pointer;
                }
              }

              .img_item:nth-child(3n) {
                margin-right: 0;
              }

              .add_img {
                width: 120px;
                height: 120px;
                background-color: #eaeaea;
                cursor: pointer;
                text-align: center;

                // margin-left: 10px;
                img {
                  width: 57px;
                  height: 57px;
                  margin-top: 30px;
                }
              }
            }

            input {
              display: none;
            }
          }
        }
      }
    }
  }
}

.talk_box {
  width: 100%;
  margin-top: 20px;

  .talk_tabs {
    // position: relative;
    width: 100%;
    height: 60px;
    background-color: #fff;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #eaeaea;

    .tabs_item {
      width: 170px;
      height: 100%;
      line-height: 60px;
      text-align: center;
      font-size: 20px;
      color: #029aff;
      cursor: pointer;
      opacity: 0.6;

      .line {
        border-bottom: 1px solid #029aff;
      }
    }

    .fabu {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      width: 100px;
      font-size: 16px;
      color: #9a9a9a;
      cursor: pointer;

      img {
        width: 26px;
        height: 26px;
        margin-right: 8px;
      }
    }
  }

  .talk_body {
    .talk_top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 20px;
      box-sizing: border-box;
      width: 100%;
      height: 50px;
      background-color: #fff;
      border-bottom: 1px solid #eaeaea;

      .top_left {
        font-size: 20px;
        color: #f5cb1f;
        display: flex;
        align-items: center;

        img {
          width: 25px;
          height: 23px;
          margin-right: 10px;
        }
      }

      .top_rt {
        display: flex;
        align-items: center;
        font-size: 18px;
        color: #343434;

        img {
          width: 16px;
          height: 18px;
          margin-left: 10px;
        }
      }
    }

    .tie_list {
      margin-bottom: 40px;

      .tie_item {
        padding: 25px;
        box-sizing: border-box;
        background-color: #fff;
        display: flex;
        margin-bottom: 10px;

        .tie_left {
          color: #333;
          font-size: 14px;
          text-align: center;
          margin-right: 20px;

          img {
            width: 54px;
            height: 54px;
            border-radius: 50%;
          }
        }

        .tie_tight {
          width: 100%;
          cursor: pointer;
          .tie_title {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 10px;

            div:nth-child(1) {
              font-size: 18px;
              color: #333;
            }

            div:nth-child(2) {
              font-size: 14px;
              color: #999;

              // cursor: pointer;
              img {
                width: 15px;
                height: 17px;
                vertical-align: top;
              }
            }
          }

          .tie_desc {
            font-size: 14px;
            color: #656565;
            line-height: 2;
            cursor: pointer;
          }

          .tie_img {
            width: 380px;
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            margin: 20px 0;

            img {
              width: 120px;
              height: 120px;
              margin-bottom: 10px;
            }
          }

          .tie_btm {
            display: flex;
            align-items: center;
            justify-content: space-between;

            .btm_left {
              font-size: 16px;
              color: #333;

              span {
                color: #0199ff;
                cursor: pointer;
              }
            }

            .btm_right {
              display: flex;
              align-items: center;

              .btm_item {
                display: flex;
                align-items: center;
                font-size: 14px;
                color: #999;

                img {
                  margin-right: 8px;
                }

                .img1 {
                  width: 19px;
                  height: 19px;
                  cursor: pointer;
                }

                .img2 {
                  width: 18px;
                  height: 16px;
                  cursor: pointer;
                }

                .img3 {
                  width: 12px;
                  height: 16px;
                }
              }

              .btm_item:nth-child(2) {
                margin: 0 30px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
